import $ from "jquery";
import React from 'react';
import Grid from 'material-ui-next/Grid';
import Paper from 'material-ui-next/Paper';
import CSSModules from 'react-css-modules';
import styles from './main.css';
import mapLimit from 'async/mapLimit';
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import RecurringIcon from '../../assets/icons/recurringIcon.react.js';
import AccountCircleIcon from '../../assets/icons/accountCircleIcon.react.js';
import MonetizationIcon from '../../assets/icons/monetizationOnFixIcon.react.js';
import {
  withStyles
} from 'material-ui-next/styles';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  RadialBarChart,
  RadialBar
} from 'recharts';

const user_list_url = config.server + config.api_path + '/employee/clients'
const device_list_url = config.server + config.api_path +
  '/employee/box_subses'

const dollar_string = (string) => (
  '$ ' + string
)

const DashStyles = theme => ({
  blue: {
    color: '#279af1',
  },
  green: {
    color: '#ff6b6b',
  },
  yellow: {
    color: '#ffe04c',
  },
  icon: {
    height: 50,
    width: 50,
    marginTop: 1 * theme.spacing.unit,
    marginBottom: 0.9 * theme.spacing.unit
  },
  right: {
    textAlign: 'right'
  },
  center: {
    textAlign: 'center'
  },
  content: {
    flexGrow: 1,
    overflow: 'hidden',
    marginBottom: 1 * theme.spacing.unit
  },
  showText: {
    marginTop: 1 * theme.spacing.unit,
    [theme.breakpoints.up('md')]: {
      marginLeft: -3 * theme.spacing.unit
    }
  },
  stats: {
    fontWeight: 'bold',
    fontSize: '1.4em',
    textAlign: 'center',
  },
  statsTitleGrid: {
    marginTop: 1 * theme.spacing.unit
  },
  statsTitleGridSmallFont: {
    fontSize: '90%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '100%',
      marginTop: 1 * theme.spacing.unit
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '100%',
    }
  },
  statsName: {
    fontSize: '1.0em',
    textAlign: 'center',
    width: '100%'
  },
  radialWrapper: {
    maxWidth: 200,
    maxHeight: 200,
    marginLeft: `calc(50% - 100px)`,
    '& .CircularProgressbar-path': {
      stroke: '#279af1',
    },
    '& .CircularProgressbar-trail': {
      stroke: '#eaeaea',
    },
    '& .CircularProgressbar-text': {
      dominantBaseline: 'middle',
      textAnchor: 'middle',
      fontSize: '70%',
    }
  },
  graphTitle: {
    marginLeft: 2 * theme.spacing.unit,
    marginTop: 0.5 * theme.spacing.unit,
  },
  graphBody: {
    marginLeft: `calc(50% - 280px)`,
    overflowX: 'auto',
    overflowY: 'hidden',
    '& .recharts-cartesian-axis-tick-value': {
      fontSize: '0.75em'
    }
  },
  gridBigBox: {
    minHeight: 350
  },
  radialLegend: {
    marginTop: 1 * theme.spacing.unit
  }
})

const info_list = {
  users: {
    title: 'Total Clients',
    load_data: (cb) => {
      $.get({
          dataType: 'json',
          url: user_list_url,
          data: auth.with_session({}),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            cb(null, data.ret.count)
          } else {
            cb(new Error(_err.em))
          }
        })
    },
    render: (self, config) => {
      const {
        classes
      } = self.props
      return (
        <Grid container className={classes.content}>
          <Grid item xs={1} lg={2}>
          </Grid>
          <Grid item xs={3} lg={2} className={classes.right}>
            <AccountCircleIcon className={[classes.blue, classes.icon]} />
          </Grid>
          <Grid item xs={6} className={[classes.showText]}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <div className={classes.stats}>
                  {self.state.users || 0}
                </div>
              </Grid>
              <Grid item xs={12} className={classes.statsTitleGrid}>
                <div className={classes.statsName}>
                  {config.title}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  },
  total_income: {
    title: 'Monthly Recurring Revenue',
    render: (self, config) => {
      const {
        classes
      } = self.props

      return (
        <Grid container className={classes.content}>
          <Grid item xs={1} lg={2}>
          </Grid>
          <Grid item xs={3} lg={2} className={classes.right}>
            <RecurringIcon className={[classes.green, classes.icon]} />
          </Grid>
          <Grid item xs={6} className={[classes.showText]}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <div className={classes.stats}>
                  {dollar_string(self.state.total_income || 0)}
                </div>
              </Grid>
              <Grid item xs={12} className={classes.statsTitleGridSmallFont}>
                <div className={classes.statsName}>
                  {config.title}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  },
  ytd_income: {
    title: 'YTD Income',
    render: (self, config) => {
      const {
        classes
      } = self.props

      return (
        <Grid container className={classes.content}>
          <Grid item xs={1} lg={2}>
          </Grid>
          <Grid item xs={3} lg={2} className={classes.right}>
            <MonetizationIcon className={[classes.yellow, classes.icon]} />
          </Grid>
          <Grid item xs={6} className={[classes.showText]}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <div className={classes.stats}>
                  {dollar_string(self.state.total_income || 0)}
                </div>
              </Grid>
              <Grid item xs={12} className={classes.statsTitleGrid}>
                <div className={classes.statsName}>
                  {config.title}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  },
  devices_details: {
    title: 'Device Overview',
    load_data: (cb) => {
      $.get({
          dataType: 'json',
          url: device_list_url,
          data: auth.with_session({}),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            const total = data.ret.count
            const sold = data.ret.results.reduce(
              (acc, current) => {
                return acc + ((current.client) ? 1 : 0)
              }, 0
            )
            const income = data.ret.results.reduce(
              (acc, current) => {
                return acc + ((current.client && current.price) ?
                  current.price.price - current.pricing.monthly.price :
                  0)
              }, 0.0
            )
            cb(null, {
              devices_total: total,
              sold_devices: sold,
              devices_to_sell: total - sold,
              total_income: income.toFixed(2)
            })
          } else {
            cb(new Error(_err.em))
          }
        })
    },
    render: (self, config) => {
      const {
        classes
      } = self.props
      const data = [{
          name: "Total",
          value: self.state.devices_total || 0,
          fill: '#3ed5ad',
        },
        {
          name: "Sold",
          value: self.state.sold_devices || 0,
          fill: '#279af1',
        },
      ]
      const renderLegend = (props) => {
        return (
          <div className={classes.radialLegend}>
          {
            (
              (Math.round(self.state.sold_devices * 100.0 / self.state.devices_total) || 0)
              + ' % Sold')
          }
          </div>
        );
      }

      return (
        <Grid container className={[classes.content, classes.gridBigBox]}>
          <Grid item xs={12} className={classes.graphTitle}>
            {config.title}
          </Grid>
          <Grid item xs={12}>
            <ResponsiveContainer minHeight={120}>
              <RadialBarChart
                innerRadius={80}
                outerRadius={100}
                data={data}
                startAngle={210}
                endAngle={-30}
                cy="56%"
              >
                <RadialBar
                  minAngle={15}
                  background
                  clockWise={true}
                  dataKey='value' />
                <Legend
                  iconSize={10}
                  layout='vertical'
                  verticalAlign='middle'
                  content={renderLegend}
                />
              </RadialBarChart>
            </ResponsiveContainer>
          </Grid>
          <Grid item xs={12} className={classes.center}>
            <Grid container spacing={0}>
              <Grid item xs>
                <Grid container spacing={0}>
                  <Grid xs={12} className={classes.stats}>
                    {self.state.devices_total || 0}
                  </Grid>
                  <Grid xs={12} className={classes.statsTitleGridSmallFont}>
                    Total
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs className={classes.center}>
                <Grid container spacing={0}>
                  <Grid xs={12} className={classes.stats}>
                    {self.state.sold_devices || 0}
                  </Grid>
                  <Grid xs={12} className={classes.statsTitleGridSmallFont}>
                    Sold
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs className={classes.center}>
                <Grid container spacing={0}>
                  <Grid xs={12} className={classes.stats}>
                    {(self.state.devices_total - self.state.sold_devices) || 0}
                  </Grid>
                  <Grid xs={12} className={classes.statsTitleGridSmallFont}>
                    In Stock
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )
    }
  },
  activations: {
    title: 'Activations past 12 months',
    cols: 2,
    load_data: (cb) => {
      cb(null, {
        activations: [{
            month: 'Jan',
            new_act: 2000,
            deact: -283
          },
          {
            month: 'Feb',
            new_act: 3000,
            deact: -198
          },
          {
            month: 'Mar',
            new_act: 2908,
            deact: -900
          },
          {
            month: 'Apr',
            new_act: 3780,
            deact: -308
          },
          {
            month: 'May',
            new_act: 2892,
            deact: -482
          },
          {
            month: 'Jun',
            new_act: 2395,
            deact: -392
          },
          {
            month: 'Jul',
            new_act: 3490,
            deact: -332
          },
          {
            month: 'Aug',
            new_act: 2997,
            deact: -232
          },
          {
            month: 'Sep',
            new_act: 5090,
            deact: -32
          },
          {
            month: 'Oct',
            new_act: 3423,
            deact: -132
          },
          {
            month: 'Nov',
            new_act: 4211,
            deact: -132
          },
          {
            month: 'Dec',
            new_act: 5238,
            deact: -432
          },
        ]
      })
    },
    render: (self, config) => {
      const {
        classes
      } = self.props
      return (
        <Grid container className={[classes.content, classes.gridBigBox]}>
          <Grid item xs={12} className={classes.graphTitle}>
            {config.title}
          </Grid>
          <Grid item xs={12}>
            <ResponsiveContainer
              className={classes.graphBody}
              width={540}
              minHeight={200}
            >
              <BarChart
                data={self.state.activations}
                barSize={30}
                stackOffset="sign"
              >
                <XAxis dataKey="month"/>
                <YAxis tickSize={2}/>
                <CartesianGrid strokeDasharray="3 3"/>
                <Tooltip/>
                <Legend />
                <Bar
                  name="New Activations"
                  dataKey="new_act"
                  label={{ fill: '#fff', fontSize: 10, position: 'insideTop' }}
                  stackId="a"
                  fill="#8884d8" />
                <Bar
                  name="Deactivations"
                  dataKey="deact"
                  label={{ fill: '#000', fontSize: 10, position: 'top' }}
                  stackId="a"
                  fill="#3DD5AD" />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      )
    }
  }
}

class DashboardView extends React.Component {
  constructor(props) {
    super(props)

    this.info_list = info_list
    this.state = {}
  }

  componentDidMount() {
    var self = this;
    mapLimit(
      Object.keys(this.info_list),
      3,
      (id, next) => {
        if (this.info_list[id].load_data) {
          this.info_list[id].load_data((err, data) => {
            if (!err) {
              var _data = {
                [id]: data
              }
              if (data instanceof Object) {
                _data = data
              }
              self.setState(_data, () => {
                next(err, data)
              })
            } else next(err, data)
          })
        } else {
          next()
        }
      },
      (err, results) => {}
    )
  }

  render() {
    var self = this
    return (
      <div styleName="dash-card">
        <Grid container>
          {
            Object.keys(this.info_list).map((id) => {
              const info_config = this.info_list[id]
              const cols = info_config.cols || 1
              return (
                <Grid
                  item
                  key={id}
                  md={cols * 4}
                  xs={12}
                  >
                  <Paper>
                    <div>
                      {info_config.render(self, info_config)}
                    </div>
                  </Paper>
                </Grid>
              )
            })
          }
        </Grid>
      </div>
    )
  }
}

export default CSSModules(withStyles(DashStyles)(DashboardView), styles)



// WEBPACK FOOTER //
// ./src/views/dashboard/main.react.js